import type { PropsWithChildren } from "react";
import styles from "./Container.module.css";

export function Container(props: PropsWithChildren<{}>): JSX.Element {
  return <div className={styles.Container}>{props.children}</div>;
}
